import PATHS from './routes.const';

export const AUTH_EVENT_SLUG_PREFIX = 'events/';

interface AuthFlowPaths {
  basePaths: string[];
  brandPaths: string[];
}

export const AUTH_PATHS: Record<
  'resetPassword' | 'recoverPassword' | 'login' | 'storeSignUp',
  AuthFlowPaths
> = {
  resetPassword: {
    basePaths: ['/resetar-senha', '/reset-password'],
    brandPaths: [],
  },
  recoverPassword: {
    basePaths: ['/recuperar-senha', '/recover-password'],
    brandPaths: [
      '/events/:slug/recuperar-senha',
      '/events/:slug/recover-password',
      '/:slug/recuperar-senha',
      '/:slug/recover-password',
    ],
  },
  login: {
    basePaths: ['/login'],
    brandPaths: ['/events/:slug', '/:slug/login'],
  },
  storeSignUp: {
    basePaths: ['/cadastrar-loja', '/store-sign-up'],
    brandPaths: [
      '/events/:slug/cadastrar-loja',
      '/events/:slug/store-sign-up',
      '/:slug/cadastrar-loja',
      '/:slug/store-sign-up',
    ],
  },
};

const AUTH_FLOW_PATHS = Object.values(AUTH_PATHS);

export const AUTH_BASE_PATHS = AUTH_FLOW_PATHS.flatMap(({ basePaths }) => basePaths);

export const AUTH_BRAND_PATHS = AUTH_FLOW_PATHS.flatMap(({ brandPaths }) => brandPaths);

const withRedirectPath = (path: string, search?: string) => {
  const redirectPath = new URLSearchParams(search).get('redirectPath');

  return redirectPath ? `${path}?redirectPath=${encodeURIComponent(redirectPath)}` : path;
};

export const getAuthLoginPath = (slug?: string, search?: string) => {
  if (!slug) {
    return withRedirectPath(PATHS.public.login.path, search);
  }

  const path = slug.startsWith(AUTH_EVENT_SLUG_PREFIX) ? `/${slug}` : `/${slug}/login`;

  return withRedirectPath(path, search);
};

export const getAuthStoreSignUpPath = (slug?: string, search?: string) => {
  if (!slug) {
    return withRedirectPath(PATHS.public.cadastrarLoja.path, search);
  }

  return withRedirectPath(`/${slug}/cadastrar-loja`, search);
};
